import metaCreativeVelocityMockData from '@/assets/mockData/spyder/metaCreativeVelocity.json'
import brandPartnersMockData from '@/assets/mockData/spyder/brandPartners.json'
import adRankScatterMockData from '@/assets/mockData/spyder/adRankScatter.json'
import creativeTestDayAdsMockData from '@/assets/mockData/spyder/creativeTestDay.json'

import moment from 'moment'

export function getMetaCreativeVelocityMockData() {
  return _.cloneDeep(metaCreativeVelocityMockData)
}

export function getBrandPartnersMockData() {
  return _.cloneDeep(brandPartnersMockData)
}

export function getAdRankScatterMockData() {
  return _.cloneDeep(adRankScatterMockData)
}

// Takes the landing pages data from brand.analytics.landing_pages
// Returns the data normalized for display in LandingPagesBrandView
export function normalizeLandingPagesMockData(landingPages) {
  return landingPages.map(page => ({
    ...page,
    landing_page: page.url
  }))
}

export function getCreativeTestDaysMockData () {
  // Create an array of YYYY-MM-DD string for the last 20 days
  const days = []
  for (let i = 0; i < 20; i++) {
    days.push(moment().subtract(i, 'days').format('YYYY-MM-DD'))
  }
  return days.map(date => ({ date, count: 4, liveCount: 0 })) 
}

export function getCreativeTestDayAdsMockData () {
  return _.cloneDeep(creativeTestDayAdsMockData)
}